import { render, staticRenderFns } from "./NotificationGDPR.vue?vue&type=template&id=4496ac74&scoped=true&"
import script from "./NotificationGDPR.vue?vue&type=script&lang=ts&"
export * from "./NotificationGDPR.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationGDPR.vue?vue&type=style&index=0&id=4496ac74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4496ac74",
  null
  
)

export default component.exports